import styled from "@emotion/styled";
import { Stack } from "@mui/material";
import { User } from "@phosphor-icons/react";

const Container = styled.div`
  padding: 32px;
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  flex: 1;
`;

const Title = styled.div``;

const Stat = styled.div`
  font-weight: 700;
  font-size: 32px;
`;

export const PledgeCard = ({ title, stat }) => {
  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Title>{title}</Title>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <User size={32} weight="bold" />
        <Stat>{Number(stat).toLocaleString()}</Stat>
      </Stack>
    </Container>
  );
};
